<template>
  <el-container>
    <el-header class="appNav">
      <div class="header-inner">
        <!-- 左侧 LOGO+平台名 -->
        <div class="header-left cursor-pointer">
          <span class="platform-title">{{ $t('common.platformTitle') }}</span>
        </div>
        <!-- 右侧菜单 -->
        <div class="header-right">
          <!-- <el-button type="default" class="lang-btn" @click="goHome" :aria-label="$t('common.home')">
            {{ $t('common.home') }}
          </el-button> -->
          <el-button type="default" class="lang-btn" @click="toggleLang" :aria-label="$t('common.switchLang')">
            {{ lang === 'zh' ? $t('common.en') : $t('common.zh') }}
          </el-button>
          <!-- <el-button type="default" class="lang-btn" @click="goHelp" :aria-label="$t('common.help')">
            {{ $t('common.help') }}
          </el-button> -->
        </div>
      </div>
    </el-header>
    <el-main class="appMain">
      <router-view />
    </el-main>
    <el-footer class="appFooter">
      <div class="text-center">
        <p class="text-sm">
          © {{ dayjs().format("YYYY") }} FutureFlu Platform. {{ $t('common.copyright') }}
        </p>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
import dayjs from 'dayjs'


export default {
  name: 'mobile',
  data() {
    return {
      dayjs: dayjs,

    }
  },

  computed: {
    lang() {
      return this.$i18n.locale
    }
  },
  methods: {
    toggleLang() {
      const newLang = this.$i18n.locale === 'zh' ? 'en' : 'zh'
      this.$i18n.locale = newLang
      // 保存语言设置到localStorage
      localStorage.setItem('language', newLang === 'zh' ? 'zh-CN' : 'en-US')
    },
    goHome() {
      this.$router.push('/')
    },
    goHelp() {
      this.$router.push('/help')
    },
  }
}
</script>

<style scoped lang="scss">
.appNav {
  background: linear-gradient(135deg, #1f2937 0%, #374151 100%);
  color: #fff;
  padding: 0;
  height: 60px;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1000;
  backdrop-filter: blur(10px);
}

.header-inner {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}



.platform-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.5px;
  user-select: none;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.year-select {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  min-width: 90px;
  height: 36px;
  backdrop-filter: blur(10px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.year-select:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
}

.lang-btn {
  background: rgba(255, 255, 255, 0.95);
  color: #1f2937;
  border: none;
  border-radius: 8px;
  min-width: 40px;
  height: 36px;
  font-weight: 600;
  font-size: 13px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.lang-btn:hover {
  background: #fff;
}

.appMain {
  height: calc(100vh - 90px);
  padding: 0;
  overflow-y: auto;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.appFooter {
  height: 30px;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  color: #64748b;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  border-top: 1px solid #e2e8f0;
  backdrop-filter: blur(10px);
}
</style>